// Shared module-level cache for engagement financial field modifications.
// Persists across route changes within the same browser session.
// Key: engagementId
// Value: { usd_amount, estimated_profit, pfa_status, status, planned_fee_adjustment, pfa_usd }

const userModifiedCache = new Map();

export default userModifiedCache;
